import React, { useRef, useState } from "react";
import { Button, Loader } from "@fluentui/react-northstar";
import styles from "./mobileUpload.module.scss";
import pl from "shared/messages/pl";
import { ResponsiveDialog } from "ecom-teams-apps-core";
import { calculateFileSize } from "../../utils/fileUtils";

interface MobileUploadProps {
    fileSizeLimit: number;

    onUpload: (files: File[]) => Promise<void>;
}

const MobileUpload: React.FC<MobileUploadProps> = (props: MobileUploadProps) => {
    const fileUploadRef = useRef<HTMLInputElement | null>(null);
    const [isBusy, setIsBusy] = useState(false);
    const [isValidationErrorDialogVisible, setIsValidationErrorDialogVisible] = useState(false);

    const onUpload = async (target: EventTarget & HTMLInputElement) => {
        if (!target.files?.length) {
            return;
        }

        const file = target.files[0];

        if (file.size > props.fileSizeLimit) {
            setIsValidationErrorDialogVisible(true);
            return;
        }

        setIsBusy(true);
        await props.onUpload([file]);
        setIsBusy(false);
    };

    return isBusy ? (
        <Loader
            labelPosition="end"
            size="small"
            title={pl.taskDetails.attachments.loading.add}
            label={pl.taskDetails.attachments.loading.add}
        />
    ) : (
        <>
            <input
                ref={fileUploadRef}
                onChange={async (e) => {
                    await onUpload(e.currentTarget as EventTarget & HTMLInputElement);
                }}
                type="file"
                style={{ display: "none" }}
                multiple={false}
            />
            <Button
                content={pl.taskDetails.attachments.add}
                className={styles.uploadButton}
                primary
                fluid
                onClick={() => fileUploadRef.current?.click()}
            />
            <ResponsiveDialog
                confirmButton={pl.common.close}
                onConfirm={() => {
                    setIsValidationErrorDialogVisible(false);
                }}
                open={isValidationErrorDialogVisible}
                header={pl.taskDetails.attachments.validationError.header}
                content={pl.taskDetails.attachments.validationError.contents.fileTooLarge(
                    calculateFileSize(props.fileSizeLimit)
                )}
            />
        </>
    );
};

export default MobileUpload;
